import { createContext } from "react";
import { v4 as uuid } from "uuid";
import Cookies from "universal-cookie";

export const AppContext = createContext(null);

const AppProvider = ({ children }) => {
  const cookies = new Cookies();
  let unique_id = "";
  // Check stored session id
  let sessionId = cookies.get("newton-session-id");
  if (sessionId) {
    unique_id = sessionId;
  } else {
    // New unique id
    unique_id = uuid();
    cookies.set("newton-session-id", unique_id);
  }

  return (
    <AppContext.Provider value={unique_id}>{children}</AppContext.Provider>
  );
};

export default AppProvider;
